import { Link } from 'react-router-dom';

export default function Footer() {
  const year = 2026;
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="font-seal flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50">
                师
              </span>
              <div className="leading-tight">
                <p className="font-heading text-lg font-bold text-foreground-950">师兄啊师兄</p>
                <p className="text-xs tracking-[0.2em] text-foreground-500">考据 · 嗑糖 · 追更</p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              专注于《师兄啊师兄》的人物关系考据、CP线发展脉络与师门日常高甜片段整理，为同好们提供一份能安心追更、慢慢嗑糖的指南。
            </p>
            <div className="mt-5 flex items-center gap-3 text-foreground-500">
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 transition-colors hover:border-primary-300 hover:text-primary-600">
                <i className="ri-weibo-line" />
              </a>
              <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 transition-colors hover:border-primary-300 hover:text-primary-600">
                <i className="ri-bilibili-fill" />
              </a>
              <a href="#" aria-label="视频号" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 transition-colors hover:border-primary-300 hover:text-primary-600">
                <i className="ri-play-circle-line" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">内容栏目</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/characters" className="text-foreground-600 transition-colors hover:text-primary-600">人物关系图谱</Link></li>
              <li><Link to="/cp" className="text-foreground-600 transition-colors hover:text-primary-600">CP线专题</Link></li>
              <li><Link to="/daily" className="text-foreground-600 transition-colors hover:text-primary-600">师门日常合集</Link></li>
              <li><Link to="/daily" className="text-foreground-600 transition-colors hover:text-primary-600">高甜名场面</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">追更指南</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/characters" className="text-foreground-600 transition-colors hover:text-primary-600">角色一览</Link></li>
              <li><Link to="/cp" className="text-foreground-600 transition-colors hover:text-primary-600">CP热度榜</Link></li>
              <li><Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-600">关于本站</Link></li>
              <li><Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-600">联系方式</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">一句话</h3>
            <p className="font-seal mt-4 text-lg leading-8 text-primary-700">一峰之人，皆是牵挂。</p>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              本站内容为同好考据整理，仅供交流分享。欢迎各位道友来信指正与投稿。
            </p>
            <p className="mt-3 text-sm text-foreground-500">联系邮箱：hello@shixiong.fan</p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {year} 师兄啊师兄考据站 · 同人内容站，一切关于《师兄啊师兄》的喜爱都值得被记录。</p>
          <p className="flex items-center gap-1">
            尊重原作 · 理性嗑糖
            <i className="ri-heart-3-line text-primary-500" />
          </p>
        </div>
      </div>
    </footer>
  );
}